<template>
  <v-app-bar class="header" app color="white" fixed>
    <div class="header-start">
      <router-link to="/" exact>
        <div class="header-start__prepend">
          <div class="header-start__prepend_title">St. Jude</div>
          <div class="header-start__prepend_subtitle">Partner Summit 2021</div>
        </div>
        <div class="header-start__separator"></div>
        <span class="header-start__append">
          <img src="@/assets/logo__append.png" alt="The Power of One" />
        </span>
      </router-link>
    </div>
    <HeaderNav />
    <div class="header-end">
      <v-btn
        @click="$emit('input', !value)"
        icon
        x-small
        class="sidebar-drawer"
      >
        <v-icon color="#EE3624" size="42">
          {{ value ? "$menuclose" : "$menu" }}
        </v-icon>
      </v-btn>
    </div>
  </v-app-bar>
</template>

<script>
import HeaderNav from "./Header/HeaderNav";

export default {
  components: { HeaderNav },
  props: {
    value: Boolean
  },
  computed: {
    rootUrl() {
      return `/${this.activePage?.slug || ""}`;
    }
  }
};
</script>

<style scoped lang="scss">
@import "@/styles/variables.scss";

.header::v-deep {
  .v-toolbar__content {
    background: white;
    justify-content: space-between;
    padding: 0;
  }
}

.header {
  transition: 0.3s;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1) !important;
  padding: 0 20px;
  height: $header-height !important;

  &::v-deep .v-toolbar__content {
    transition: 0.3s;
    height: 100px !important;
  }
  &-logo {
    width: 225px;
    height: 70px;
    background-image: url(~@/assets/header-logo.png);
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
  }
}

.header-start a {
  text-decoration: none;
}

.header-start {
  display: flex;
  align-items: center;
  padding: 20px;
  padding-left: 40px;

  a {
    display: flex;
    align-items: center;
  }

  &__prepend {
    color: $primary;
    &_title {
      font-weight: 800;
      font-size: 24px;
    }
    &_subtitle {
      font-weight: 600;
      font-size: 16px;
    }
  }

  &__separator {
    width: 2px;
    height: 67px;
    background: #b1b3b3;
    margin: 5px 20px;
  }

  &__append {
    img {
      width: 141px;
    }
  }
}

.header-end {
  display: none;
}

.sidebar-drawer,
.gift-btn-mobile {
  display: none;
}

@media screen and (max-width: 960px) {
  .sidebar-drawer {
    display: block !important;
  }
  .gift-btn-mobile {
    display: flex;
    margin-right: 19px;
  }

  .header {
    height: $header-height-mobile !important;
    &::v-deep .v-toolbar__content {
      height: $header-height-mobile !important;
    }
    &-logo {
      width: 125px;
      height: 40px;
    }

    &-start {
      justify-content: space-between;
      padding: 10px 10px 10px 0;

      &__prepend {
        color: $primary;
        &_title {
          font-size: 16px;
        }
        &_subtitle {
          font-size: 12px;
        }
      }
      &__separator {
        width: 1px;
        height: 39px;
        margin: 5px 11px;
      }

      &__append {
        height: 44px;
        img {
          width: 83px;
        }
      }
    }

    &-start,
    &-end {
      display: flex;
      align-items: center;
    }

    &-end {
      padding: 0;
      margin-top: -20px;
    }
  }
}
</style>
